<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="indicadores"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
>
</sgt-multi-select>
